import PropTypes from "prop-types";
import React, { Component } from "react";
import shallowequal from "shallowequal";
import _ from "lodash";
import { DeliveryWindows } from "./delivery-windows";
import { DeliveryDates } from "./delivery-dates";
import { Form } from "formsy-react";
import Toggle from "components/form/toggle";
import theme from "styles/theme";
import { merge, $ } from "glamor";
import { format } from "lib/globalize-util";
import moment from "moment";
import { DELIVERY_WINDOW_NONE, DELIVERY_WINDOW_SELECT_DATE } from "constants/delivery-window-types";
import { AddHintBadge } from "components/hint-badge";
import LabelledSwitch from "components/form/labelled-switch";
import { DATATEST } from "constants/integration";

export const deliveryWindowDisplayName = (deliveryWindow) => {
    const start = moment.utc(deliveryWindow.ship_start).format("MMM DD, YYYY");
    const end = moment.utc(deliveryWindow.ship_end).format("MMM DD, YYYY");
    const fallback = `${start} - ${end}`;
    return deliveryWindow.display_name ? deliveryWindow.display_name : fallback;
};

class CatalogDeliveryWindows extends Component {
    static propTypes = {
        catalog: PropTypes.object.isRequired,
        editable: PropTypes.bool,
        scope: PropTypes.object.isRequired,
        fetchingWindows: PropTypes.bool.isRequired,
        requireCatalogDates: PropTypes.bool,
        displayAsLabel: PropTypes.bool,
        isNewModalEnabled: PropTypes.bool,
    };

    styles = merge(
        $(" .toggle-hint", {
            height: "29px",
            alignItems: "center",
        }),
        $(" .toggle-container", {
            marginTop: "16px",
            width: "100%",
        }),
        $(" .deliveryWindowForm", {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
        }),
        $(" .toggle-container", {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
        }),
        $(" .pickerWrapper", {
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
        })
    );

    muiStyles = {
        iconButton: {
            // position: "absolute",
            // right: "0px",
            // top: "14px",
            marginRight: "10px",
        },
        tooltip: {
            height: "36px",
            width: "36px",
            color: theme.palette.lighterGrey,
        },
        prebookTooltip: {
            width: "220px",
        },
        prebookToggle: {
            width: "100%",
        },
        toggleLabel: {
            whiteSpace: "break-spaces",
        },
        deliveryWindowTooltip: {
            marginTop: "10px",
            left: "30px",
        },
        labelWrapper: {
            float: "left",
            width: "33%",
            boxSizing: "border-box",
        },
        labelLabel: {
            fontSize: "12px",
            color: theme.palette.darkGrey,
            margin: "0px 0px 4px",
        },
        labelText: {
            fontSize: "16px",
            lineHeight: 1.5,
            color: theme.palette.darkerGrey,
        },
    };

    static defaultProps = {
        editable: false,
        isNewModalEnabled: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            displayDatePickers: false,
            prebook: props.prebook,
            deliveryWindowStart: props.deliveryWindowStart,
            deliveryWindowEnd: props.deliveryWindowEnd,
        };

        this.handleDeliveryWindowChange = this.handleDeliveryWindowChange.bind(this);
        this.handleDeliveryDatesChange = this.handleDeliveryDatesChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { catalog } = this.props;
        if (catalog.on) {
            catalog.on("change", this.handleModelChange, this);
        }
    }

    componentWillUnmount() {
        const { catalog } = this.props;
        if (catalog.off) {
            catalog.off("change", this.handleModelChange, this);
        }
    }

    handleModelChange() {
        this.forceUpdate();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !shallowequal(this.props, nextProps) || !shallowequal(this.state, nextState);
    }

    handleDeliveryWindowChange(deliveryWindowId) {
        const { scope, deliveryWindowStart, deliveryWindowEnd } = this.props;
        let displayDatePickers = false;
        if (deliveryWindowId === DELIVERY_WINDOW_SELECT_DATE) {
            displayDatePickers = true;
            if (!deliveryWindowStart && !deliveryWindowEnd) {
                const changes = {
                    delivery_window_start: moment.utc().valueOf(),
                    delivery_window_end: moment
                        .utc()
                        .add(scope.brand.getPreference("minimum_delivery_window"), "days")
                        .valueOf(),
                    prebook: null,
                };
                this.setState(changes);
                this.handleValueChange(changes);
            }
        } else if (deliveryWindowId === DELIVERY_WINDOW_NONE) {
            const changes = {
                delivery_window_start: null,
                delivery_window_end: null,
                prebook: null,
            };
            this.setState(changes);
            this.handleValueChange(changes);
        } else {
            const deliveryWindow = this.props.deliveryWindows.find((dw) => dw._id === deliveryWindowId);
            if (deliveryWindow) {
                const changes = {
                    delivery_window_start: deliveryWindow.ship_start,
                    delivery_window_end: deliveryWindow.ship_end,
                    prebook: deliveryWindow.prebook,
                };
                this.setState(changes);
                this.handleValueChange(changes);
            }
        }
        this.setState({ deliveryWindowId, displayDatePickers });
    }

    handleDeliveryDatesChange(deliveryWindowStart, deliveryWindowEnd) {
        const changes = { delivery_window_start: deliveryWindowStart, delivery_window_end: deliveryWindowEnd };
        if (!deliveryWindowStart && !deliveryWindowEnd) {
            changes.prebook = false;
            this.setState({ deliveryWindowId: DELIVERY_WINDOW_NONE, displayDatePickers: false });
        }
        this.handleValueChange(changes);
    }

    handleValueChange(changes) {
        const { onDeliveryWindowChange } = this.props;
        if (onDeliveryWindowChange) {
            onDeliveryWindowChange(changes);
        }
    }

    render() {
        const { catalog, editable, scope, fetchingWindows, requireCatalogDates, displayAsLabel, isNewModalEnabled } =
            this.props;
        const { displayDatePickers } = this.state;
        let selectedDeliveryWindowId;

        const deliveryWindowStart = catalog.delivery_window_start;
        const deliveryWindowEnd = catalog.delivery_window_end;
        if (!editable) {
            return null;
        }

        let preSelectedDeliveryWindow;

        if (this.props.deliveryWindows && deliveryWindowStart && deliveryWindowEnd) {
            preSelectedDeliveryWindow = this.props.deliveryWindows.find((dw) => {
                const deliveryStartMatch = moment.utc(dw.ship_start).isSame(deliveryWindowStart, "day");
                const deliveryEndMatch = moment.utc(dw.ship_end).isSame(deliveryWindowEnd, "day");
                // const prebookMatch = !!dw.prebook === !!catalog.prebook; // Prebook no longer important to match against
                return deliveryStartMatch && deliveryEndMatch; //&& prebookMatch;
            });
        }

        // If we don't have the deliveryWindowId, try to find it based on the dates and prebook flag
        if (preSelectedDeliveryWindow && !displayDatePickers) {
            selectedDeliveryWindowId = preSelectedDeliveryWindow._id;
        } else if (displayDatePickers || (deliveryWindowStart && deliveryWindowEnd) || requireCatalogDates) {
            selectedDeliveryWindowId = DELIVERY_WINDOW_SELECT_DATE;
        } else {
            selectedDeliveryWindowId = DELIVERY_WINDOW_NONE;
        }

        let datePickers;
        const useCatalog = scope.brand.hasPreference("linesheets_are_catalogs");
        let resourceName = useCatalog ? "Catalog" : "Linesheet";
        resourceName = catalog.type === "linesheet" ? resourceName : "List";
        const toggles = isNewModalEnabled ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <LabelledSwitch
                    label={format("Only prebook products")}
                    dataTest={DATATEST.CATALOG.ONLY_PREBOOK_PRODUCTS_TOGGLE}
                    labelPosition="right"
                    onChange={this.handleChange("prebook")}
                    checked={catalog.prebook}
                />
                <LabelledSwitch
                    label={format("Visible after delivery dates expire")}
                    dataTest={DATATEST.CATALOG.VISIBLE_AFTER_EXPIRED_TOGGLE}
                    checked={!catalog.hide_when_expired}
                    onChange={this.handleChange("hide_when_expired")}
                    labelPosition="right"
                />
            </div>
        ) : (
            <>
                <Toggle
                    label={format("Only prebook products")}
                    data-test={DATATEST.CATALOG.ONLY_PREBOOK_PRODUCTS_TOGGLE}
                    defaultToggled={catalog.prebook}
                    onToggle={this.handleChange("prebook")}
                    labelPosition="right"
                    style={this.muiStyles.prebookTooltip}
                />
                <AddHintBadge hint="Hide when expired Hint" variables={{ Linesheet: format(resourceName) }}>
                    <Toggle
                        label={format("Visible after delivery dates expire")}
                        data-test={DATATEST.CATALOG.VISIBLE_AFTER_EXPIRED_TOGGLE}
                        defaultToggled={!catalog.hide_when_expired}
                        onToggle={this.handleChange("hide_when_expired")}
                        labelPosition="right"
                        style={this.muiStyles.prebookToggle}
                        labelStyle={this.muiStyles.toggleLabel}
                    />
                </AddHintBadge>
            </>
        );

        if (selectedDeliveryWindowId === DELIVERY_WINDOW_SELECT_DATE) {
            datePickers = (
                <div className="pickerWrapper">
                    <DeliveryDates
                        minimum_delivery_window={scope.brand.getPreference("minimum_delivery_window")}
                        deliveryWindowStart={deliveryWindowStart}
                        deliveryWindowEnd={deliveryWindowEnd}
                        onChange={this.handleDeliveryDatesChange}
                        requireCatalogDates={requireCatalogDates}
                    />
                    <div className="toggle-container" data-test={DATATEST.CATALOG.TOGGLE_CONTAINER}>
                        {toggles}
                    </div>
                </div>
            );
        }

        if (displayAsLabel) {
            let displayLabelValue;
            if (selectedDeliveryWindowId === DELIVERY_WINDOW_SELECT_DATE && deliveryWindowStart && deliveryWindowEnd) {
                displayLabelValue = `${moment.utc(deliveryWindowStart).format("MMM DD, YYYY")} - ${moment
                    .utc(deliveryWindowEnd)
                    .format("MMM DD, YYYY")}`;
            } else {
                const brandDeliveryWindow = this.props.deliveryWindows?.find(
                    (window) => window._id === selectedDeliveryWindowId
                );
                if (brandDeliveryWindow) {
                    displayLabelValue = deliveryWindowDisplayName(brandDeliveryWindow);
                }
            }

            return (
                <div style={this.muiStyles.labelWrapper}>
                    <div style={this.muiStyles.labelLabel}>{format("Delivery:")}</div>
                    <div style={this.muiStyles.labelText}>{displayLabelValue || format("None")}</div>
                </div>
            );
        }

        const deliveryWindowForm = isNewModalEnabled ? (
            <>
                <DeliveryWindows
                    catalog={catalog}
                    scope={scope}
                    deliveryWindowEntities={this.props.deliveryWindows}
                    onDeliverWindowChange={this.handleDeliveryWindowChange}
                    value={selectedDeliveryWindowId}
                    fetchingWindows={fetchingWindows}
                    requireCatalogDates={requireCatalogDates}
                    isNewModalEnabled={isNewModalEnabled}
                />
                <p style={{ fontSize: "14px" }}>
                    {format("Products that are not available during the selected dates will not be visible to buyers.")}
                </p>
            </>
        ) : (
            <AddHintBadge
                hint="Products that are not available during the selected dates will not be visible to buyers"
                elements={{ br: "" }}
                badgeStyle={this.muiStyles.deliveryWindowTooltip}
            >
                <DeliveryWindows
                    catalog={catalog}
                    scope={scope}
                    deliveryWindowEntities={this.props.deliveryWindows}
                    onDeliverWindowChange={this.handleDeliveryWindowChange}
                    value={selectedDeliveryWindowId}
                    fetchingWindows={fetchingWindows}
                    requireCatalogDates={requireCatalogDates}
                />
            </AddHintBadge>
        );

        return (
            <div {...this.styles}>
                <Form>
                    <div className="deliveryWindowForm" data-test={DATATEST.CATALOG.DELIVERY_WINDOW_FORM}>
                        {deliveryWindowForm}
                        {deliveryWindowStart && deliveryWindowEnd && !datePickers && (
                            <div className="toggle-container" data-test={DATATEST.CATALOG.TOGGLE_CONTAINER}>
                                {toggles}
                            </div>
                        )}
                    </div>
                    {datePickers}
                </Form>
            </div>
        );
    }

    handleChange = _.memoize((field) => (event, value) => {
        if (field === "hide_when_expired") {
            value = !value; // label is inverted from value in db on account of product changes
        }
        return this.handleValueChange({ [field]: value });
    });
}

export default CatalogDeliveryWindows;
